import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CookieBanner } from "@/components/site/CookieBanner";
import Home from "@/pages/Home";
import SubPage from "@/pages/SubPage";
import LegalPage from "@/pages/LegalPage";
import RatgeberIndex from "@/pages/RatgeberIndex";
import RatgeberArticle from "@/pages/RatgeberArticle";
import LandingBess from "@/pages/LandingBess";
import LandingBessDanke from "@/pages/LandingBessDanke";
import LandingSalesAgent from "@/pages/LandingSalesAgent";
import LandingSalesAgentDanke from "@/pages/LandingSalesAgentDanke";
import PersonalHub from "@/pages/PersonalHub";
import PersonalDanke from "@/pages/PersonalDanke";
import RollePage from "@/pages/RollePage";
import JobsIndex from "@/pages/JobsIndex";
import JobDetail from "@/pages/JobDetail";
import LexikonIndex from "@/pages/LexikonIndex";
import LexikonTerm from "@/pages/LexikonTerm";
import subpages from "@/data/subpages.json";
import legal from "@/data/legal.json";
import ratgeber from "@/data/ratgeber.json";
import personal from "@/data/personal.json";
import jobs from "@/data/jobs.json";
import lexikon from "@/data/lexikon.json";

function App() {
  return (
    <BrowserRouter>
      <CookieBanner />
      <Routes>
        <Route path="/" element={<Home />} />
        {Object.entries(subpages).map(([slug, data]) => (
          <Route key={slug} path={`/${slug}`} element={<SubPage data={data} />} />
        ))}
        {Object.entries(legal).map(([slug, data]) => (
          <Route key={slug} path={`/${slug}`} element={<LegalPage data={data} />} />
        ))}
        <Route path="/personalvermittlung" element={<PersonalHub />} />
        <Route path="/personalvermittlung/danke" element={<PersonalDanke />} />
        {Object.keys(personal.rollen).map((slug) => (
          <Route key={slug} path={`/personalvermittlung/${slug}`} element={<RollePage slug={slug} />} />
        ))}
        <Route path="/jobs" element={<JobsIndex />} />
        {Object.keys(jobs.landings).map((slug) => (
          <Route key={slug} path={`/jobs/${slug}`} element={<JobsIndex landingSlug={slug} />} />
        ))}
        {Object.keys(jobs.stellen).map((slug) => (
          <Route key={slug} path={`/jobs/${slug}`} element={<JobDetail slug={slug} />} />
        ))}
        <Route path="/lexikon" element={<LexikonIndex />} />
        {Object.keys(lexikon).map((slug) => (
          <Route key={slug} path={`/lexikon/${slug}`} element={<LexikonTerm slug={slug} />} />
        ))}
        <Route path="/lp/batteriespeicher-leads" element={<LandingBess />} />
        <Route path="/lp/batteriespeicher-leads/danke" element={<LandingBessDanke />} />
        <Route path="/lp/sales-agent-bruehl" element={<LandingSalesAgent />} />
        <Route path="/lp/sales-agent-bruehl/danke" element={<LandingSalesAgentDanke />} />
        <Route path="/ratgeber" element={<RatgeberIndex />} />
        {Object.entries(ratgeber).map(([slug, data]) => (
          <Route key={slug} path={`/ratgeber/${slug}`} element={<RatgeberArticle data={data} />} />
        ))}
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
